const ContactHeader = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
          Contacto
        </h1>

        <p className="text-xl text-gray-600 leading-relaxed">
          ¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para ayudarte.
          Contáctanos y te responderemos lo antes posible.
        </p>
      </div>
    </div>
  </section>
);

export default ContactHeader;
